const metaItemActive = {
  itemActive: 'Modalities',
};
export default [
  {
    path: '/modalities',
    name: 'Modalities',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Modalities',
      crud: {
        pageTitle: 'app.modalities.title',
        showCard: false,
        pageContent: () => import('App/modalities/Modalities.vue'),
      },
    },
  },
  {
    path: '/modalities/config/:id',
    name: 'ModalitiesConfig',
    component: () => import('App/modalities/ModalitiesConfigForm.vue'),
    meta: metaItemActive,
  },
];
